import ValidatableComponent from "./ValidatableComponent";

export default {
    methods : {
        async moveToStep(stepId, options) {
            this.$store.commit('set_step_loading', true)
            options = options || {};
            const doValidate = options.validate === undefined ? true : options.validate;
            const doSubmit = options.submit === undefined ? true : options.submit;
            try {
                if (doValidate) {
                    let validationResult = await this.stepValidate();
                    if (validationResult !== true) {
                        throw {exception: 'validate', data: validationResult};
                    }
                }
                if (doSubmit) {

                    let submissionResult = await this.stepSubmit();

                    if (submissionResult !== true) {
                        throw {exception: 'submit', data: submissionResult};
                    }
                }
                if (!options.stay)
                    this.currentStepId = stepId;
            } catch (e) {
                console.log(e);
            }

            this.$store.commit('set_step_loading', false)
        },
        async stepNext(options) {
            return await this.moveToStep(this.currentStepId + 1, options)
        },
        async stepBack(options) {
            if(this.$store.state.resources.config.google_recaptcha=="1" && this.$store.state.resources.config.google_recaptcha_site_key!=''){
                this.$store.commit('set_disabled_status', false);
            }
            return await this.moveToStep(this.currentStepId - 1, options)
        },
        async stepValidate() {
            if(this.v__isValidatable) {
                const res = await this.validate();
                if (res) {
                    this.$store.commit('set_step_success', {id: this.$store.state.currentStepId});
                } else {
                    this.$store.commit('set_step_error', {
                        id   : this.$store.state.currentStepId,
                        error: 'Validation error'
                    });
                }
                return res;
            }
            return true;
        },
        async stepSubmit() {
            //Implement step submission
            return true;
        }
    },
    computed: {
        currentStepId: {
            get() {
                return this.$store.state.currentStepId;
            },
            set(n) {
                this.$store.commit('set_step_id', n);
            }
        },
        currentStep() {
            return this.steps.find(s => s.id === this.currentStepId);
        },
        steps() {
            return this.$store.state.steps;
        },

    }
}
